import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Phone, Clock, ArrowUpRight } from "lucide-react";
import { CLINICS } from "../../data/clinics";

export const ClinicsBand = () => {
  return (
    <section
      data-testid="clinics-section"
      className="py-20 md:py-28"
    >
      <div className="container-app">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#88A096] mb-3">
              As nossas clínicas
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight">
              Duas portas abertas <span className="text-[#1E5F6E]">na Madeira</span>.
            </h2>
            <p className="mt-4 text-base md:text-lg text-[#5A5A5A] leading-relaxed">
              Estamos próximos da sua casa, com a mesma equipa e o mesmo cuidado.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {CLINICS.map((c, i) => (
            <motion.article
              key={c.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`clinic-card-${c.slug}`}
              className="group relative overflow-hidden rounded-3xl bg-white border border-[#1E5F6E]/8 p-7 md:p-9 shadow-soft hover:shadow-glow hover:-translate-y-1 transition-all duration-300"
            >
              <div
                className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-[#88A096]/15 group-hover:scale-110 transition-transform duration-500"
                aria-hidden
              />
              <div className="relative">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#88A096]">
                      Clínica {i + 1}
                    </div>
                    <h3 className="mt-2 font-display text-2xl md:text-[28px] font-bold text-[#1A1A1A]">
                      {c.nome}
                    </h3>
                    <p className="text-sm text-[#5A5A5A] mt-1">{c.nomeOficial}</p>
                  </div>
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-[#1E5F6E]/8 text-[#1E5F6E]">
                    <MapPin className="h-5 w-5" />
                  </span>
                </div>

                <dl className="mt-7 space-y-3.5 text-[15px]">
                  <div className="flex gap-3">
                    <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#88A096]" />
                    <span className="text-[#1A1A1A]">
                      {c.morada}, {c.codigoPostal} {c.cidade}
                    </span>
                  </div>
                  <div className="flex gap-3">
                    <Phone className="h-4 w-4 mt-0.5 shrink-0 text-[#88A096]" />
                    <a
                      href={`tel:${c.telefoneE164}`}
                      data-testid={`clinic-phone-${c.slug}`}
                      className="text-[#1E5F6E] font-semibold hover:underline underline-offset-4"
                    >
                      {c.telefone}
                    </a>
                  </div>
                  <div className="flex gap-3">
                    <Clock className="h-4 w-4 mt-0.5 shrink-0 text-[#88A096]" />
                    <span className="text-[#5A5A5A]">{c.horarioResumo}</span>
                  </div>
                </dl>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <Link
                    to={`/clinicas/${c.slug}`}
                    data-testid={`clinic-view-${c.slug}`}
                    className="inline-flex items-center justify-center gap-1.5 rounded-full bg-[#1E5F6E] px-5 py-3 text-sm font-bold text-white hover:bg-[#174E5B] transition-colors"
                  >
                    Ver clínica
                    <ArrowUpRight className="h-4 w-4" />
                  </Link>
                  <a
                    href={`tel:${c.telefoneE164}`}
                    data-testid={`clinic-call-${c.slug}`}
                    className="inline-flex items-center justify-center gap-1.5 rounded-full bg-white border-2 border-[#1E5F6E]/15 px-5 py-3 text-sm font-bold text-[#1E5F6E] hover:border-[#1E5F6E]/40 transition-colors"
                  >
                    <Phone className="h-4 w-4" />
                    Ligar agora
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClinicsBand;
